import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

type GenderKey = 'mensPlural' | 'womensPlural' | 'genders.male' | 'genders.female' | 'boysPlural' | 'girlsPlural';

export const useGenderDisplayName = (eventCategory: string) => {
  const { t } = useTranslation();
  const [male, female] = useMemo(() => {
    return ((): GenderKey[] => {
      if (eventCategory === 'ADULT') return ['mensPlural', 'womensPlural'];
      if (eventCategory === 'WTN_PLAY') return ['genders.male', 'genders.female'];
      return ['boysPlural', 'girlsPlural'];
    })().map((tKey) => t(tKey));
  }, [eventCategory, t]);

  return useMemo(() => ({ male, female }), [male, female]);
};
